import type { SessionFilter } from '../stores'
import type { ChatSession } from '../types'

// The Mine/Team/All split, shared by the session list and the auto-open hook
// so "which threads count as mine" is defined in exactly one place.
export function matchesSessionFilter(
  session: ChatSession,
  filter: SessionFilter,
): boolean {
  if (filter === 'mine') return session.mine
  if (filter === 'team') return !session.mine
  return true
}
